'use client';

import styled from 'styled-components';

import { breakpoints } from '@styles/breakpoint';
import { Spacers } from '@styles/theme';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  gap: 3.625rem;

  ${breakpoints.desktopOrBigger} {
    gap: 0rem;
  }
`;

export const TopContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4.5rem;

  ${breakpoints.desktopOrBigger} {
    gap: 6.5rem;
  }
`;

export const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 0.5rem;
  padding: ${Spacers.BASE}rem;
  gap: ${Spacers.XS}rem;
  text-align: center;
  background-color: ${(props) => props.theme.colors.backgroundAccent};
`;

export const TextHeBottomInfo = styled.span`
  color: ${({ theme }) => theme.colors.typographyBodyLight};
  font-size: ${({ theme }) => theme.typography.body.fontSize};
  font-weight: ${({ theme }) => theme.typography.body.fontWeight};
  line-height: ${({ theme }) => theme.typography.body.lineHeight};
  white-space: pre-line;
`;
